import { AccessoryDetailValue, AccessoryType, AccessoryValue, StorageData } from '@smart-home/common';

export const getValue = <TData extends AccessoryValue, T extends AccessoryType = AccessoryType>(type: T, id: string, data: StorageData | null) => {
  const source = data?.[type] as AccessoryDetailValue<AccessoryValue>[];
  return (source?.find((x) => x.id === id))?.value as TData;
};
